import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm = this.fb.group({
    username: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]]
  });
  get loginFormControl() { return this.loginForm.controls }

  loginUser() {
    // console.log(this.loginForm.value);
    this._authService.loginUser(this.loginForm.value);

  }

  constructor(private fb: FormBuilder, private _authService: AuthService) { }

  ngOnInit(): void {
  }

}
